import {MI} from "../init";
import {getArrayRandValue, shuffleArray} from "../../framework/src/helpers";
import MadnesTween from "../libs/mi/MadnesTween";
import {he, wi} from "../../framework/src/engine/madnes/madnes_variables";

/**
 * @class BigWin
 * @param {Game} game
 * @constructor
 * @returns {undefined}
 */
export default function BigWin(game) {

    /** @type {Game}*/
    this._game = game;

    /** @type {MadnesObject}*/
    this._bigwinSign;
    /** @type {MadnesObject}*/
    this._bigwinSign2;
    /** @type {MadnesObject}*/
    this._bigwinText;

    /** @type {MadnesObject}*/
    this.fsSign;
    /** @type {MadnesObject}*/
    this.fsSign2;

    /** @type {MadnesGraphics} */
    this._blackScreen;

    this._shineLoop = 0;

    /** @type {MadnesTween} */
    this._shineTweenRed;
    /** @type {MadnesTween} */
    this._shineTweenBlue;

    this._requestStopTween = false;
    /** @type {Function} */
    this._moveResolve;

    this.bigWinLeftDustPos = [
        { x: 268, y: 330 }, { x: 394, y: 384 }, { x: 495, y: 370 },
        { x: 370, y: 314 }, { x: 546, y: 326 }, { x: 334, y: 320 }
    ];
    this.bigWinRightDustPos = [
        { x: 1032, y: 440 }, { x: 950, y: 300 }, { x: 890, y: 400 },
        { x: 684, y: 288 }, { x: 804, y: 378 }, { x: 798, y: 350 },
    ];
    this.bigWinCenterDustPos = [
        { x: 638, y: 288 }, { x: 556, y: 356 }, { x: 668, y: 276 }
    ];



    this.fsLeftDustPos = [
        { x: 210, y: 376 }, { x: 360, y: 310 }, { x: 512, y: 206 },
        { x: 266, y: 275 }, { x: 396, y: 232 }, { x: 488, y: 273 }
    ];
    this.fsRightDustPos = [
        { x: 1042, y: 382 }, { x: 882, y: 300 }, { x: 733, y: 207 },
        { x: 984, y: 274 }, { x: 801, y: 241 }, { x: 931, y: 253 },

    ];
    this.fsCenterDustPos = [
        { x: 544, y: 245 }, { x: 662, y: 234 }, { x: 794, y: 241 }
    ];

    /** @type {MadnesGroup} */
    this._signGroup = game.assets.bigWinGroupSign;
    /** @type {MadnesGroup} */
    this._dustGroupPre = game.assets.bigWinPreGroupDust;

    /** @type {MadnesGroup} */
    this._dustGroupPost = game.assets.bigWinPostGroupDust;

    /** @type {MadnesGroup} */
    this._textGroup = game.assets.bigWinGroupText;
    /** @type {MadnesGroup} */
    this._shinesGroup = game.assets.bigWinGroupShines;

    /** @type {MadnesTimer} */
    this._textBgTimer;
}

BigWin.prototype.create = function() {

    this._blackScreen = this._game.assets.bigWinBlackScreen;

    this._shineLoop = 0;
    this._requestStopTween = false;

    this._bigwinSign = MI.addImg(MI.getWi() / 2, MI.getHe() / 2, "bigwin_sign").setAnchor(0.5, 0.5).setScale(0.2, 1).setAlpha(0);
    this._bigwinSign2 = MI.addImg(MI.getWi() / 2, MI.getHe() / 2, "bigwin_sign").setAnchor(0.5, 0.5).setVisible(false).setBlend("SCREEN");
    this._signGroup.add(this._bigwinSign);
    this._signGroup.add(this._bigwinSign2);

    this._createShines();

    this._bigwinText = MI.addBitmapText("font_big_win", MI.getWi() / 2, MI.getHe() / 2, "", 80).setAnchor(0.5, 0.5);
    this._textGroup.add(this._bigwinText);
};

BigWin.prototype.createFreeSpin = function() {

    this._blackScreen = this._game.assets.bigWinBlackScreen;

    this._shineLoop = 0;
    this._requestStopTween = false;

    this._fsSign = MI.addImg(MI.getWi() / 2, MI.getHe() / 2 - 60, "freespins_sign").setAnchor(0.5, 0.5).setScale(0.2, 1).setAlpha(0);
    this._fsSign2 = MI.addImg(MI.getWi() / 2, MI.getHe() / 2 - 60, "freespins_sign").setAnchor(0.5, 0.5).setVisible(false).setBlend("ADD");
    this._signGroup.add(this._fsSign);
    this._signGroup.add(this._fsSign2);

    this._createShines();

    this._bigwinText = MI.addBitmapText("font_big_win", MI.getWi() / 2, MI.getHe() / 2 + 90, "", 80).setAnchor(0.5, 0.5);
    this._textGroup.add(this._bigwinText);
};

BigWin.prototype._createShines = function() {
    this._bigwinShineRed = MI.addImg(-wi, he, "bigwin_shine_atlas").setFrameName("bigwin_shine_red_small2").setAnchor(0, 1).setBlend("ADD").setScale(2.5, 2.8);
    this._shinesGroup.add(this._bigwinShineRed);
    this._bigwinShineBlue = MI.addImg(wi, 0, "bigwin_shine_atlas").setFrameName("bigwin_shine_blue_small2").setAnchor(0, 0).setBlend("ADD").setScale(2.5, 2.8);
    this._shinesGroup.add(this._bigwinShineBlue);
};

//BigWin.prototype._createBlackScreen = function() {};

BigWin.prototype.destroy = function() {
    //this._blackScreen && this._blackScreen.destroy();
    this._bigwinSign && this._bigwinSign.destroy();
    this._bigwinSign2 && this._bigwinSign2.destroy();
    this._bigwinShineRed && this._bigwinShineRed.destroy();
    this._bigwinShineBlue && this._bigwinShineBlue.destroy();
    this._bigwinText && this._bigwinText.destroy();

    this._moveResolve = null;

    this._textBgTimer = null;
};

BigWin.prototype.scaleInSign = function() {

    var _self = this;

    return new Promise(function(res) {

        MI.addTween().to(_self._bigwinSign, { 'alpha': 1 }, {
            'duration': 400
        });

        MI.addTween().to(_self._bigwinSign, { x: 1 }, {
            'scale': true,
            'easing': MadnesTween.getEasing("back_out"),
            'duration': 400,
            'callback': function() {

                _self._bigwinSign2.setVisible(true);

                MI.addTween().to(_self._bigwinSign2, { 'alpha': 0 }, {
                    'duration': 500,
                    'callback': function() {
                        _self._bigwinSign2 && _self._bigwinSign2.destroy();
                        setTimeout(res, 600 + 600);
                    }
                });

                MI.addTween().to(_self._bigwinSign2, { 'x': 1.5, 'y': 1.5 }, {
                    'scale': true,
                    'duration': 600,
                });
            }
        });
    }).then(function() {

        var randLeft = _self.getRandPosFrom(_self.bigWinLeftDustPos, 4);
        var randRight = _self.getRandPosFrom(_self.bigWinRightDustPos, 4);
        var randCenter = _self.getRandPosFrom(_self.bigWinCenterDustPos, 2);
        var rand = shuffleArray(randLeft.concat(randRight, randCenter));

        for(var i = 0; i < rand.length; i++) {
            (function(i) {
                setTimeout(function() {
                    //console.log(rand[i], i);
                    _self._game.assets.dust(rand[i]['x'], rand[i]['y'], 3, 50, 0x4cd8eb, 80, _self._dustGroupPre, _self._dustGroupPost);
                }, (i + 2)  * 100);
            } (i));
        }

        return new Promise(function(res) {
            setTimeout(res, 800 + 400);
        });

    }).then(function() {

        return new Promise(function(res) {
            MI.addTween().to(_self._bigwinSign, { 'alpha': 0 }, {
                'duration': 500,
                'callback': function() {
                    _self._bigwinSign.destroy();
                    res();
                }
            });
        });
    });
};

/**
 * @param {Array} array
 * @param {number} count
 * @returns {Array}
 */
BigWin.prototype.getRandPosFrom = function(array, count) {

    var arr = [];

    if(count > array.length) {
        count = array.length;
    }

    while(arr.length < count) {
        var pos = getArrayRandValue(array);
        var add = true;
        for(var i = 0; i < arr.length; i++) {
            if(arr[i]['x'] === pos["x"] && arr[i]['y'] === pos["y"]) {
                add = false;
            }
        }
        if(add) {
            arr.push({ 'x': pos["x"], 'y': pos["y"] });
        }
    }

    return arr;
};

BigWin.prototype.moveShines = function() {

    setTimeout(function() {

        this._bigwinShineRed.setPosX(-wi);
        this._bigwinShineBlue.setPosX(wi);

        this._shineTweenRed = MI.addTween().to(this._bigwinShineRed, { 'x': MI.getWi() / 2 }, {
            'duration': 1500,
            'yoyo': true,
            'easing': MadnesTween.getEasing("quadratic_in_out"),
            'count': -1,
            'onLoop': function() {
                if(++this._shineLoop % 2 === 0 && this._requestStopTween) {
                    this._shineTweenRed.stop();
                    this._shineTweenBlue.stop();
                    this._moveResolve();
                }
            }.bind(this)
        });

        this._shineTweenBlue = MI.addTween().to(this._bigwinShineBlue, { 'x': MI.getWi() / 2 * -1 }, {
            'duration': 1500,
            'yoyo': true,
            'easing': MadnesTween.getEasing("quadratic_in_out"),
            'count': -1
        });

    }.bind(this), 600);
};

BigWin.prototype.setText = function(val) {
    this._bigwinText.setText((val * 1) | 0);
};

/**
 * @returns {Promise}
 */
BigWin.prototype.pulseText = function() {

    var _self = this;

    return new Promise(function(res) {

        MI.addTween().to(_self._bigwinText, { 'x': 1.1, 'y': 1.1 }, {
            'scale': true,
            'duration': 300,
            'yoyo': true,
            'count': 1,
            'callback': function() {
                MI.addTween().to(_self._bigwinText, { 'alpha': 0 }, {
                    'duration': 300,
                    'callback': function() {
                        _self._bigwinText.destroy();
                        res();
                    }
                });
            }
        });
    });
};

BigWin.prototype.animTextBgDustStart = function() {

    var _self = this;

    this._game.assets.dust(MI.getWi() / 2, MI.getHe() / 2, 3, 80, 0x4cd8eb, 150, this._dustGroupPre, this._dustGroupPost);

    this._textBgTimer = MI.createTimer();
    this._textBgTimer.loop(function() {

        _self._game.assets.dust(MI.getWi() / 2, MI.getHe() / 2, 3, 80, 0x4cd8eb, 150, _self._dustGroupPre, _self._dustGroupPost);

    }, 500);
    //this._bigwinText.setText((val * 1) | 0);
};

BigWin.prototype.animTextBgDustStop = function() {
    this._textBgTimer.stop();
};

///**
// * @param {number=} delay
// * @returns {Promise}
// */
//BigWin.prototype.fadeInBlackScreen = function(delay) {
//
//	delay = delay ? delay : 0;
//
//	this._blackScreen.setAlpha(0);
//	this._blackScreen.setVisible(true);
//
//	return new Promise(function(res) {
//		MI.addTween().to(this._blackScreen, { 'alpha': 0.7 }, {
//			'delay': delay,
//			'duration': 250,
//			'callback': res
//		});
//	}.bind(this));
//};

/**
 * @returns {Promise}
 */
BigWin.prototype.fadeOutBlackScreen = function() {

    return new Promise(function(res) {
        MI.addTween().to(this._blackScreen, { 'alpha': 0 }, {
            'duration': 250,
            'callback': function() {
                this._blackScreen.setVisible(false);
                //this._blackScreen.destroy();
                res();
            }.bind(this)
        });
    }.bind(this));
};

/**
 * @returns {Promise}
 */
BigWin.prototype.stopShines = function() {
    this._requestStopTween = true;

    return new Promise(function(res) {
        this._moveResolve = res;
    }.bind(this));
};

/**
 * @returns {Promise}
 */
BigWin.prototype.dustStart = function(delay) {

    var _self = this;

    return new Promise(function(res) {

        _self._game.assets.dust(MI.getWi() / 2, MI.getHe() / 2, 4, 60, 0x4cd8eb, 150, _self._dustGroupPre, _self._dustGroupPost);

        setTimeout(res, delay);
    });
};

BigWin.prototype.dustFSStart = function() {

    var _self = this;

    return new Promise(function(res) {

        _self._game.assets.dust(MI.getWi() / 2, MI.getHe() / 2 - 90, 4, 60, 0x4cd8eb, 150, _self._dustGroupPre, _self._dustGroupPost);

        setTimeout(res, 700);
    });
};


BigWin.prototype.scaleInSignFS = function() {

    var _self = this;

    return new Promise(function(res) {

        MI.addTween().to(_self._fsSign, { 'alpha': 1 }, {
            'duration': 100
        });

        MI.addTween().to(_self._fsSign, { x: 1 }, {
            'scale': true,
            'easing': MadnesTween.getEasing("back_out"),
            'duration': 600,
            'callback': function() {

                _self._fsSign2.setVisible(true);

                MI.addTween().to(_self._fsSign2, { 'alpha': 0 }, {
                    'duration': 700,
                    'callback': function() {
                        _self._fsSign2 && _self._fsSign2.destroy();
                        res();
                    }
                });

                MI.addTween().to(_self._fsSign2, { 'x': 1.5, 'y': 1.5  }, {
                    'scale': true,
                    'duration': 600,
                });

            }
        });
    });
};

BigWin.prototype.smokeOutFs = function() {

    var _self = this;

    var randLeft = this.getRandPosFrom(this.fsLeftDustPos, 4);
    var randRight = this.getRandPosFrom(this.fsRightDustPos, 4);
    var randCenter = this.getRandPosFrom(this.fsCenterDustPos, 3);
    var rand = shuffleArray(randLeft.concat(randRight, randCenter));

    for(var i = 0; i < rand.length; i++) {
        (function(i) {
            setTimeout(function() {
                //console.log(rand[i], i);
                _self._game.assets.dust(rand[i]['x'], rand[i]['y'], 4, 50, 0x4cd8eb, 120, _self._dustGroupPre, _self._dustGroupPost);
            }, (i + 2)  * 180);
        } (i));
    }

//	return new Promise(function(res) {
//		setTimeout(res, 2500);
//	});
};

BigWin.prototype.fadeOutSignFS = function(delay) {

    return new Promise(function(res) {

        MI.addTween().to(this._bigwinText, { 'alpha': 0 }, {
            'duration': 800,
            'delay': delay,
            'callback': function() {
                this._bigwinText.destroy();
            }.bind(this)
        });

        MI.addTween().to(this._fsSign, { 'alpha': 0 }, {
            'duration': 830,
            'delay': delay,
            'callback': function() {
                this._fsSign.destroy();
                res();
            }.bind(this)
        });


    }.bind(this));

};